export default "__VITE_ASSET__BPcidLJx__"